import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledReservationPreferenceSelect = styled(Select)`
   width: 250px;
` as typeof Select;
